/**
 * One-open accordion policy shared by Rakenne Talotekniikka and Vyöhykkeet rows.
 * Extracted so bun:test can cover the rules without a DOM.
 */

/** Click-to-toggle: the same id collapses; any other id becomes the sole open row. */
export function next_open_row_id(
  current: string | null,
  clicked: string,
): string | null {
  return current === clicked ? null : clicked;
}

/**
 * Rows start collapsed. An explicit collapse (null after init) is kept.
 * If the open row leaves the list (filter), stay collapsed — do not pick another.
 */
export function reconcile_open_row_id(
  current: string | null,
  ids: readonly string[],
  initialized: boolean,
): { open_id: string | null; initialized: boolean } {
  if (ids.length === 0) {
    return { open_id: null, initialized };
  }
  if (!initialized) {
    return { open_id: null, initialized: true };
  }
  if (current === null) {
    return { open_id: null, initialized: true };
  }
  if (ids.includes(current)) {
    return { open_id: current, initialized: true };
  }
  return { open_id: null, initialized: true };
}

/** Tallenna/Peruuta follow dirtiness only — open vs collapsed does not hide them. */
export function dirty_actions_visible(dirty: boolean): boolean {
  return dirty;
}
